import { ofType, Epic } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { AjaxResponse, AjaxError } from 'rxjs/ajax';
import { get } from '__utils/ajax-wrapper';
import { FluxStandardAction } from '__utils/type';
import { ENDPOINTS } from 'constants/endpoints';
import * as Actions from 'constants/actions';
import resolveURLParams from '__utils/url-params-resolver';
import { fetchAllMintpacksSuccess } from './renderView.actions';
import { EMPTY } from 'rxjs';

export const getAllMintpacksEpic: Epic<FluxStandardAction, FluxStandardAction> = action$ => {
    return action$.pipe(
        ofType(Actions.FETCH_GET_ALL_MINTPACKS),
        mergeMap(() => {
            return EMPTY;
        })
    );
};